export const tiposEspeciesFlorestais = {
  ESPECIE_FLORESTAL: 'ESPECIE_FLORESTAL',
  ESPECIE_FRUTIFERA: 'ESPECIE_FRUTIFERA',
  ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO: 'ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO',
  ESPECIE_ADUBEIRAS_OU_DE_SERVICO: 'ESPECIE_ADUBEIRAS_OU_DE_SERVICO'
}



// WEBPACK FOOTER //
// ./src/libs/utils/enums/enum.js